import React, { useState, Fragment } from 'react'

import { Form, Page, Text } from '@fielded/shared-ui'
import { Upload } from '@fielded/shared-ui/src/icons'

const PSMInboundShipmentsOverviewUpload = ({
  documentFormRef,
  isUploading,
  onUploadTemplate,
  onCancel
}) => {
  const [hasValidFile, setHasValidFile] = useState(false)
  return (
    <Fragment>
      <Page.Panel.Section>
        <Text.Heading>Upload updated shipment file</Text.Heading>
        <Text>
          After filling in the shipment information in the downloaded template, upload the file here. Make sure all required fields are complete and the file is saved in the correct format (Excel) before uploading.
        </Text>
      </Page.Panel.Section>

      <Page.Panel.Section>
        <Form ref={documentFormRef} component='form'>
          <Form.Section>
            <Form.Row>
              <Form.Field
                fieldName='file'
              >
                <Form.Field.FileUploadAdvanced
                  acceptText='.xlsx'
                  required
                  onValueChange={(value) => setHasValidFile(!!value)}
                />
                <Form.Field.ValidationErrors />
              </Form.Field>
            </Form.Row>
          </Form.Section>
        </Form>
      </Page.Panel.Section>
      <Page.Footer fixed>
        <Form.Actions className='new-psm-shipment__button-wrapper'>
          <Form.Button
            icon={<Upload />}
            loading={isUploading}
            onClick={onUploadTemplate}
            disabled={!hasValidFile}
          >
            Upload file
          </Form.Button>
          <Form.Button
            variant='deemphasized'
            alignOpposite
            onClick={onCancel}
          >
            Cancel and go back
          </Form.Button>
        </Form.Actions>
      </Page.Footer>
    </Fragment>
  )
}

export default PSMInboundShipmentsOverviewUpload
